
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import _, { forEach } from "lodash";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";
import request from "@/lib/request/request";
// import ExamList from "@/lib/model/exam/exam";
import Job from "@/lib/job/job";
import ExamListForm from "@/lib/form/exam/ExamListForm";

interface TagForm {
  attribute?: string;
  mergeType: "AND" | "OR";
}

interface RuleForm {
  ruleId?: number;
  attribute: string;
  relationship: string;
  propName?: string[];
  value?: string | string[];
  value1?: string;
  value2?: string;
  key?: number;
  dataTypeList?: any;
  dataType?: string;
  valueOptions?: any;
  hasOr?: boolean;
  inputType?: string;
  tagAttrList?: any;
  valueInt?: number;
  valueRange?: [number, number];
  valueStrings?: string[];
  questionId?: number;
  paramName?: string;
  dimensionName?: string;
  checkpointName?: string;
  optionName?: string; // 普工版
  dimensionGroupName?: string;
}

interface TagApplication {
  configId?: number;
  tagStatusList?: any;
  auditDesc?: string;
  auditMember?: string;
  aiRecommendStatus?: number;
  tagName?: string;
  message?: string;
  messageType?: number;
  dimensionGroupName?: string;
  dimensionName?: string;
  dimensionLevel?: number;
  dimensionLevelDesc?: string;
  subExamId: string;
}

interface Rule {
  tagForm: TagForm;
  ruleList: RuleForm[];
  tagApplication: TagApplication;
  key?: number;
  hasOr?: boolean;
  assign?: any;
}

@Component({})
export default class TagEdit extends Vue {
  @Prop({}) exam!: ExamV2Custom;
  @Prop({}) visible!: boolean;
  @Prop({}) form!: any;
  @Prop({}) subForm!: any;
  title = "集联面试规则";

  fixedList = [
    "命中",
    "未命中",
    "部分命中",
    "部分未命中",
    "无条件命中",
    "全部未命中"
  ];
  emptyList = ["为空", "不为空"];

  ruleSetList: Rule[] = [
    {
      tagForm: {
        mergeType: "AND"
      },
      ruleList: [
        {
          attribute: "",
          relationship: "",
          value: "",
          key: 1,
          dataType: "testResult",
          propName: [],
          dataTypeList: [],
          tagAttrList: []
        }
      ],
      tagApplication: {
        subExamId: ""
      },
      key: -1
    }
  ];

  rules = {
    attribute: [{ required: true, message: "请选择", trigger: "blur" }],
    relationship: [{ required: true, message: "请选择", trigger: "blur" }],
    value: [{ required: true, message: "请输入", trigger: "blur" }]
  };
  subRules = {
    subExamId: [{ required: true, message: "请选择", trigger: "blur" }]
  };

  hasOr = false;

  ruleKey = -1;
  key = 1;

  useForm = {
    type: "",
    auditStatus: ""
  };

  subList: any = [];

  evalPropName = "";

  attributeList: any = [];
  dataTypeList: any = [{ name: "命中" }, { name: "未命中" }];
  dataTypeSpeList: any = [{ name: "必命中" }];
  tagAttrList: any = [];

  ruleUseList = [
    {
      label: "自动阅卷",
      value: "自动阅卷",
      statusList: [
        { label: "通过", value: 1 },
        { label: "待定", value: 2 },
        { label: "拒绝", value: 3 }
      ],
      propName: "auditDesc"
    },
    {
      label: "AI推荐",
      value: "AI推荐",
      statusList: [
        { label: "不推荐", value: 1 },
        { label: "一般", value: 2 },
        { label: "推荐", value: 3 },
        { label: "非常推荐", value: 4 }
      ],
      propName: ""
    },
    { label: "打标签", value: "打标签", statusList: null, propName: "tagName" }
  ];

  applicationRuleList: any = [];

  tagStatusList: any = null;

  @Watch("visible", { immediate: true })
  getForm(nval: any) {
    if (nval) {
      this.applicationRuleList = JSON.parse(
        JSON.stringify(this.exam.applicationRuleList)
      );
      this.getList();
      this.getSubList();
      // this.myForm = JSON.parse(JSON.stringify(this.form))
      // this.useForm = JSON.parse(JSON.stringify(this.subForm))
    }
  }

  created() {
    //
    // this.getList()
  }
  // 解析列表
  anaylisList() {
    const applicationRuleList = JSON.parse(
      JSON.stringify(this.exam.applicationRuleList)
    );
    const ruleSetList: Rule[] = [];
    applicationRuleList?.forEach((el: any) => {
      if (el.type === "级联面试分配") {
        this.ruleKey--;
        const tagForm: TagForm = {
          mergeType: el.matchRuleRoot?.mergeType
        };
        const ruleList = el.matchRuleRoot?.subList.map((el: any) => {
          this.key++;
          this.$set(el, "key", this.key);
          if (
            Array.isArray(el.detail?.valueStrings) &&
            el.detail?.valueStrings.length > 1
          ) {
            this.$set(el, "value", el.detail.valueStrings.join("，"));
          } else {
            this.$set(
              el,
              "value",
              el.detail?.valueStrings ? el.detail.valueStrings[0] : ""
            );
          }
          this.$set(el, "attribute", el.detail?.attribute);
          this.$set(el, "relationship", el.detail?.relationship);
          if (el.detail?.paramName && el.detail.attribute === "登记信息") {
            if (el.detail?.attribute !== "特殊逻辑") {
              this.$set(el, "propName", ["paramName"]);
              this.$set(el, "paramName", el.detail.paramName);
            }
            const tagAttrList = this.catchTagAttrList();
            this.$set(el, "tagAttrList", [tagAttrList]);
          } else if (el.detail?.cvArgName) {
            if (el.detail?.attribute !== "特殊逻辑") {
              this.$set(el, "propName", ["cvArgName"]);
              this.$set(el, "cvArgName", el.detail.cvArgName);
            }
            this.$set(el, "tagAttrList", [[{ name: "当前职位" }]]);
          }
          delete el.detail;
          return el;
        });
        const tagApplication = {
          subExamId: el.subExamId
        };
        ruleSetList.push({
          tagForm,
          ruleList,
          tagApplication,
          key: this.ruleKey
        });
      }
    });
    this.ruleSetList = ruleSetList;
  }
  addRule() {
    this.ruleKey--;
    this.ruleSetList.push({
      tagForm: {
        attribute: "无条件命中",
        mergeType: "AND"
      },
      ruleList: [
        {
          attribute: "",
          relationship: "",
          value: "",
          key: 1,
          dataType: "testResult",
          propName: [],
          dataTypeList: [],
          tagAttrList: []
        }
      ],
      tagApplication: {
        subExamId: ""
      },
      key: this.ruleKey
    });
  }

  adjustRule(index: number, type: "up" | "down") {
    const rule = this.ruleSetList[index];
    this.ruleSetList.splice(index, 1);
    if (type === "up") {
      this.ruleSetList.splice(index - 1, 0, rule);
    } else {
      this.ruleSetList.splice(index + 1, 0, rule);
    }
  }

  addTag(ruleList: RuleForm[]) {
    this.key++;
    ruleList.push({
      attribute: "",
      relationship: "",
      value: "",
      dataType: "testResult",
      key: this.key,
      propName: [],
      dataTypeList: []
    });
  }

  async getSubList() {
    const res = await Job.getAllExam(({
      onlySubExam: 1,
      returnAll: true
    } as unknown) as any);
    this.subList = res.list;
  }

  async getList() {
    // /aiExam/common/tagEngine
    const res = await request.post("/aiExam/common/tagEngine");
    const data = res.data.data;
    this.attributeList = data.attributeList.filter(
      (el: any) => el.name === "登记信息"
    );
    if (this.exam.needParseResume === 1) {
      this.attributeList.push({
        dataType: "string",
        name: "简历信息",
        extraNeedList: ["cvArgName"]
      });
    }
    this.attributeList.push({
      dataType: "string",
      name: "特殊逻辑",
      extraNeedList: []
    });
    this.anaylisList();
    // this.dataTypeList = data.dataTypeList;
  }

  changeType(value: string, tag: any, flag?: boolean) {
    this.attributeList.forEach((item: any) => {
      if (item.name === value) {
        if (!flag) {
          this.$set(tag, "relationship", "");
        }
        this.$set(tag, "dataType", item.dataType);
        // const dataTypeList = this.dataTypeList
        this.$set(tag, "dataTypeList", this.dataTypeList);
        this.$set(tag, "propName", item.extraNeedList);
        item.extraNeedList.forEach((el: any) => {
          this.$set(tag, el, "");
        });
        if (!flag) {
          this.$set(tag, tag.propName[0], tag[tag.propName[0]]);
        }
        if (tag.propName[0] === "cvArgName") {
          this.$set(tag, "tagAttrList", [[{ name: "当前职位" }]]);
        } else {
          const tagAttrList = this.catchTagAttrList();
          this.$set(tag, "tagAttrList", [tagAttrList]);
        }
      }
    });
  }

  catchTagAttrList() {
    const tagAttrList = this.exam.paramList
      .filter((el: any) => el.isShow === 1)
      .map((el: any) => ({ name: el.name }));
    return tagAttrList;
  }

  removeTag(key: number | undefined, ruleList: any, rule: any) {
    rule.ruleList = ruleList.filter((el: any) => el.key !== key);
  }

  deleteRule(key: number | undefined) {
    this.ruleSetList = this.ruleSetList.filter((el: any) => el.key !== key);
  }

  async ok() {
    //todo 一些校验可以在这里做
    const data = await this.checkData();
    if (data) {
      this.$emit("ok", data);
      this.$emit("update:visible", false);
    }
  }

  close() {
    // this.$emit("ok", this.applicationRuleList);
    this.$emit("update:visible", false);
  }

  //离开前校验
  async checkData() {
    const formList = this.$refs.form as any;
    const subFormList = this.$refs.subform as any;
    let hasError = false;
    formList.forEach((el: any) => {
      el.validate((valid: any) => {
        if (!valid) {
          hasError = true;
        }
      });
    });
    subFormList.forEach((el: any) => {
      el.validate((valid: any) => {
        if (!valid) {
          hasError = true;
        }
      });
    });
    if (hasError) {
      this.$message.error("错误");
      return;
    }
    const applicationRuleList: any = [];
    let speLog = 0;
    const ruleSetList = JSON.parse(JSON.stringify(this.ruleSetList));
    ruleSetList.forEach((rule: Rule, index: number) => {
      const applicationRule: any = {};
      applicationRule.type = "级联面试分配"; // 写死
      applicationRule.sort = index;
      applicationRule.subExamId = rule.tagApplication.subExamId;
      const subList: any = [];
      delete rule.key;
      rule.ruleList.forEach((tag: RuleForm, index: number) => {
        if (tag.attribute === "特殊逻辑") {
          speLog++;
        }
        // if (tag.value?.includes(",")) {
        //   tag.valueStrings = (tag.value as string).split(",");
        // } else
        if (tag.value?.includes("，")) {
          tag.valueStrings = (tag.value as string).split("，");
        } else {
          tag.valueStrings = [tag.value] as string[];
        }
        const deleteKeys = [
          "key",
          "value",
          "propName",
          "dataTypeList",
          "inputType",
          "valueOptions",
          "tagAttrList",
          "dataType"
        ];
        deleteKeys.forEach(key => {
          delete tag[key];
        });
        subList.push({
          ruleId: tag.ruleId,
          detail: tag,
          mergeType: "",
          subList: []
        });
      });
      const matchRuleRoot: any = {
        mergeType: rule.tagForm.mergeType,
        subList: subList
      };
      applicationRule.matchRuleRoot = matchRuleRoot;
      applicationRuleList.push(applicationRule);
    });
    if (speLog !== 1) {
      this.$message.error("请检查是否设置了唯一的兜底面试！");
      return null;
    }
    return applicationRuleList;
  }
}
